<template>
    <div class="container-fluid h-100 login">
        <div v-if="!isBrowserIE" class="row m-0 h-100 w-100">
            <nav class="col-lg-5 d-lg-block bg-dark sidebar shadow"></nav>
            <main class="auth-main col-12 col-lg-7 ms-lg-auto px-md-5 h-100 d-flex">
                <router-view />
            </main>
        </div>
        <div v-else style="text-align: center">
            <h1>{{ $tl("errors.browser.invalid.title") }}</h1>
            <p v-html="$t('errors.browser.invalid.infos')"></p>
        </div>
    </div>
</template>

<script>
export default {
    name: "AuthLayout",
};
</script>
